<template>
  <!--悬浮小广告样式的提示信息-->
  <div
    id="thediv"
    ref="thediv"
    @mouseover="clearFdAd"
    @mouseout="starFdAd"
    v-if="thedivShow"
  >
    <div class="wareWrap">
      <div class="wavename">{{ waveName }}</div>
      <div class="gbclass" @click="thedivShow = false">关闭</div>
    </div>

    <a :href="waveHref" target="_blank"
      ><img class="waveImg" :src="waveImage" border="0" />
    </a>
  </div>
</template>

<script>
import util from "../utils/util";
var interval;
export default {
  name: "wave",
  data() {
    return {
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 16,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: false,
      waveImage: "",
      // waveImage: require("../../public/1.jpg"),
      waveHref: "",
      waveName: "",
      dateStr: "",
    };
  },
  mounted() {
    this.getDate();
    this.getWaveWindow();
    interval = setInterval(this.changePos, this.delay);
  },

  methods: {
    //获取飘窗数据
    getWaveWindow() {
      let Url = util.getAjaxUrl("axiosThree");
      let UrlTw = util.getAjaxUrl("axiosOne");
      let params = {
        position: "banner",
        isOpen: 1,
        pageNumber: 1,
        pageSize: 1,
        isList: "0",
      };
      this.$http
        .post(Url + "/api/DataCmsAdvertisingManage/find", params)
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data.data);
            if (res.data.data.length === 1) {
              this.waveImage =
                UrlTw + "/api/getPicture?path=" + res.data.data[0].picUrl;
              this.waveHref = res.data.data[0].connectUrl;
              this.waveName = res.data.data[0].adName;
              //判断是否展示
              let isOpen = res.data.data[0].isOpen;
              if (isOpen === "1") {
                let startTime = new Date(res.data.data[0].startTime).getTime();
                let validTime = new Date(res.data.data[0].validTime).getTime();
                let dateTime = new Date(this.dateStr).getTime();
                if (dateTime >= startTime && dateTime <= validTime) {
                  this.thedivShow = true;
                } else {
                  this.thedivShow = false;
                }
              } else {
                this.thedivShow = false;
              }
            } else {
              this.thedivShow = false;
            }
          } else {
            this.thedivShow = false;
          }
        });
    },
    //获取年月日
    getDate() {
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      this.dateStr = year + "-" + month + "-" + day;
    },
    //js实现浮动
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      try {
        //在此运行代码
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;

        // 滚动部分跟随屏幕滚动
        // this.$refs.thediv.style.left =
        //   this.xPos +
        //   document.body.scrollLeft +
        //   document.documentElement.scrollLeft +
        //   "px";

        // this.$refs.thediv.style.top =
        //   this.yPos +
        //   document.body.scrollTop +
        //   document.documentElement.scrollTop +
        //   "px";
        // console.log(document.body.scrollTop + document.documentElement.scrollTop);
        // 滚动部分不随屏幕滚动
        this.$refs.thediv.style.left =
          this.xPos + document.body.scrollLeft + "px";
        this.$refs.thediv.style.top =
          this.yPos + document.body.scrollTop + "px";

        if (this.yon) {
          this.yPos = this.yPos + this.step;
        } else {
          this.yPos = this.yPos - this.step;
        }
        if (this.yPos < 0) {
          this.yon = 1;
          this.yPos = 0;
        }
        if (this.yPos >= height - this.Hoffset) {
          this.yon = 0;
          this.yPos = height - this.Hoffset;
        }

        if (this.xon) {
          this.xPos = this.xPos + this.step;
        } else {
          this.xPos = this.xPos - this.step;
        }
        if (this.xPos < 0) {
          this.xon = 1;
          this.xPos = 0;
        }
        if (this.xPos >= width - this.Woffset) {
          this.xon = 0;
          this.xPos = width - this.Woffset;
        }
      } catch (err) {
        //在此处理错误
      }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
  },
};
</script>

<style lang="less" scoped>
#thediv {
  z-index: 1005;
  position: fixed;
  top: 43px;
  left: 2px;
  height: 420px;
  width: 480px;
  //   overlow: hidden;
  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
  .wavename {
    width: 100%;
    text-align: center;
    font-size: 18px;
    // background-color: white;
    font-weight: 600;
    font-family: SimHei;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    cursor: pointer;
  }
}
.wareWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  // padding: 0 6px;
}
.gbclass {
  cursor: pointer;
  text-align: right;
  font-size: 13px;
  color: #b71c1c;
  position: absolute;
  top: -20px;
  right: 0;
}
</style>